var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1De3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 104,
    viewBox: "0 0 348 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_102_50)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_102_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 92C74.0914 92 92 74.0914 92 52C92 29.9086 74.0914 12 52 12C29.9086 12 12 29.9086 12 52C12 74.0914 29.9086 92 52 92Z",
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_102_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296 92C318.091 92 336 74.0914 336 52C336 29.9086 318.091 12 296 12C273.909 12 256 29.9086 256 52C256 74.0914 273.909 92 296 92Z",
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_102_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173 92C195.091 92 213 74.0914 213 52C213 29.9086 195.091 12 173 12C150.909 12 133 29.9086 133 52C133 74.0914 150.909 92 173 92Z",
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_102_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91 46H133C132.517 51.1639 132.512 53.7514 133 58H91C91.6884 53.2693 91.6603 50.6397 91 46Z",
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_102_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213 46H256C256 46 254.95 53.1859 256 58H213C213.807 53.315 213.337 50.685 213 46Z",
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M296.489 63.3173C294.792 63.3173 293.28 63.0256 291.955 62.4423C290.636 61.8514 289.595 61.0408 288.83 60.0105C288.072 58.9726 287.682 57.7756 287.659 56.4196H292.614C292.644 56.9877 292.83 57.4877 293.17 57.9196C293.519 58.3438 293.981 58.6733 294.557 58.9082C295.133 59.143 295.78 59.2605 296.5 59.2605C297.25 59.2605 297.913 59.1279 298.489 58.8627C299.064 58.5976 299.515 58.2302 299.841 57.7605C300.167 57.2908 300.33 56.7491 300.33 56.1355C300.33 55.5143 300.155 54.965 299.807 54.4877C299.466 54.0029 298.973 53.6241 298.33 53.3514C297.693 53.0786 296.936 52.9423 296.057 52.9423H293.886V49.3286H296.057C296.799 49.3286 297.455 49.1999 298.023 48.9423C298.598 48.6847 299.045 48.3286 299.364 47.8741C299.682 47.412 299.841 46.8741 299.841 46.2605C299.841 45.6771 299.701 45.1658 299.42 44.7264C299.148 44.2794 298.761 43.9309 298.261 43.6809C297.769 43.4309 297.193 43.3059 296.534 43.3059C295.867 43.3059 295.258 43.4271 294.705 43.6696C294.152 43.9044 293.708 44.2415 293.375 44.6809C293.042 45.1203 292.864 45.6355 292.841 46.2264H288.125C288.148 44.8855 288.53 43.7036 289.273 42.6809C290.015 41.6582 291.015 40.8589 292.273 40.2832C293.538 39.6999 294.966 39.4082 296.557 39.4082C298.163 39.4082 299.568 39.6999 300.773 40.2832C301.977 40.8665 302.913 41.6544 303.58 42.6468C304.254 43.6317 304.587 44.7377 304.58 45.965C304.587 47.268 304.182 48.3552 303.364 49.2264C302.553 50.0976 301.496 50.6506 300.193 50.8855V51.0673C301.905 51.287 303.208 51.8817 304.102 52.8514C305.004 53.8135 305.451 55.018 305.443 56.465C305.451 57.7908 305.068 58.9688 304.295 59.9991C303.53 61.0294 302.473 61.84 301.125 62.4309C299.777 63.0218 298.231 63.3173 296.489 63.3173Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.886 62.9991V59.4536L173.17 51.7832C173.875 51.1014 174.466 50.4877 174.943 49.9423C175.428 49.3968 175.795 48.8627 176.045 48.34C176.295 47.8097 176.42 47.2377 176.42 46.6241C176.42 45.9423 176.265 45.3552 175.955 44.8627C175.644 44.3627 175.22 43.9802 174.682 43.715C174.144 43.4423 173.534 43.3059 172.852 43.3059C172.14 43.3059 171.519 43.4499 170.989 43.7377C170.458 44.0256 170.049 44.4385 169.761 44.9764C169.473 45.5143 169.33 46.1544 169.33 46.8968H164.659C164.659 45.3741 165.004 44.0521 165.693 42.9309C166.383 41.8097 167.348 40.9423 168.591 40.3286C169.833 39.715 171.265 39.4082 172.886 39.4082C174.553 39.4082 176.004 39.7036 177.239 40.2946C178.481 40.8779 179.447 41.6885 180.136 42.7264C180.826 43.7643 181.17 44.9536 181.17 46.2946C181.17 47.1733 180.996 48.0408 180.648 48.8968C180.307 49.7529 179.697 50.7036 178.818 51.7491C177.939 52.787 176.701 54.0332 175.102 55.4877L171.705 58.8173V58.9764H181.477V62.9991H164.886Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 87C71.33 87 87 71.33 87 52C87 32.67 71.33 17 52 17C32.67 17 17 32.67 17 52C17 71.33 32.67 87 52 87Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0114 39.7266V62.9993H51.0909V44.397H50.9545L45.625 47.7379V43.3743L51.3864 39.7266H56.0114Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_102_50",
    x: 0,
    y: 0,
    width: 348,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_50"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_50",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_102_50",
    x: 6,
    y: 6,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_50"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_50",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_102_50",
    x: 250,
    y: 6,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_50"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_50",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_102_50",
    x: 127,
    y: 6,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_50"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_50",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_102_50",
    x: 85,
    y: 40,
    width: 54,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_50"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_50",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_102_50",
    x: 207,
    y: 40,
    width: 55,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_50"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_50",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1De3);
export default __webpack_public_path__ + "static/media/1de3.c0dd59322a3f4bff2c9c664f0cbf7f0b.svg";
export { ForwardRef as ReactComponent };